import React from 'react';
import {Link} from "react-router-dom";
import {Helper} from "./Helper";

export default class DailyReport extends React.Component {
	constructor() {
		super();
		let qs = window.Global.getAllQueryStrings();
		let pos = false;
		if (!qs.date) {
			qs.date = window.moment((new Date())).locale("th").format('Y-M-D');
		}
		if (window.localStorage.getItem('pos') && window.localStorage.getItem('pos') !== '') {
			qs.pos_id = JSON.parse(window.localStorage.getItem('pos')).id;
			pos = JSON.parse(window.localStorage.getItem('pos'));
		}
		this.state = {
			qs: qs,
			histories: [],
			pos: pos,
			days: [1, 2, 3, 4, 5, 6, 7],
			is_loading: true,
			summary: [],
			total_net_price: 0,
			total_cash: 0,
			total_bank_transfer: 0,
		}
	}

	componentDidMount() {
		this.fetch();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			// console.log(this.props.location);
			this.setState({
				qs: Helper.getQueryStringParams(this.props.location.search),
				is_loading: true,
			}, () => {
				this.fetch();
			})
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				qs: Helper.getQueryStringParams(this.props.location.search),
				is_loading: true,
			}, () => {
				this.fetch();
			})
		}
	}

	fetch() {
		let data = {...this.state.qs};
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/payment/daily-summary-report',
			data: data,
			done: (response) => {
				let summary = [];
				for (let _data in response.summary) {
					if (response.summary.hasOwnProperty(_data)) {
						summary.push({
							...response.summary[_data]
						});
					}
				}
				this.setState({
					histories: response.histories,
					summary: summary,
					is_loading: false
				})
			},
			fail: () => {

			}
		});
	}

	render() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     style={{background: '#f4f4f4', height: '100%', padding: '1rem'}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container"
			>
				<div className={"flex"} style={{height: '100%', overflow: 'hidden'}}>
					<div id="HeaderTop_root"
					     style={{backgroundColor: 'white', padding: '1rem', position: 'relative'}}
					     className="flex row wrap center-xs"
					>
						<div style={{
							position: 'absolute',
							left: '1rem',
							top: 0,
							display: 'flex',
							alignItems: 'center',
							height: '100%'
						}}>
							<Link to={"/v2/sale_orders/pos"} className={"ui button basic massive"}
							      style={{
								      padding: this.props.button_padding || '1.5rem',
								      fontSize: this.props.button_fontSize || '1.5rem'
							      }}
							>
								กลับ
							</Link>
						</div>
						<div>

							<div className={"ui button basic massive"}
							     id={"black-font"}
							     style={{
								     padding: this.props.button_padding || '1.5rem',
								     fontSize: this.props.button_fontSize || '1.5rem',
								     border: 0,
								     color: '#000',
								     opacity: 1,
								     boxShadow: 'none',
								     margin: 0
							     }}
							>
								<h1>สรุปยอดขายประจำวัน</h1>
							</div>
						</div>
					</div>
					<div id="selected-time" className="flex row wrap middle-xs center-xs"
					     style={{padding: '0 1rem 1rem', background: '#fff'}}>
						{
							this.state.days.map((day, day_i) => {
								let date_format = window.moment(new Date().setDate(new Date().getDate() - day_i)).format('Y-M-D');
								let day_title = window.moment(new Date().setDate(new Date().getDate() - day_i)).format('dddd');
								let qs = {...this.state.qs};
								qs.date = date_format;
								day_title = day_title + ' ' + window.moment(qs.date).locale("th").format('D MMM')
								return (
									<Link
										key={day_i}
										type="button"
										className={this.state.qs.date === date_format ? "ui button circular custom-active-btn" : "ui button circular basic"}
										to={window.Global.getQueryStringLinkFromObject(qs)}
									>
										{day_i === 0 ? "วันนี้" : null}
										{day_i === 1 ? "เมื่อวาน" : null}
										{day_i > 1 ? day_title : null}
									</Link>
								);
							})
						}
					</div>
					<div className="flex"
					     id={"Daily_root"}
					     style={{overflowY: 'auto'}}
					>
						<div className={"flex middle-xs"}>
							<div className={"daily-report-box"}>
								<div className={"daily-row-space"}>
									<h1>สรุปยอดขายประจำวัน</h1>
									<div className={"row daily-space"}>
										<div className={"font-bold font-black"}>
											{window.moment(this.state.qs.date).format('dddd')} {window.Global.getDateThai(this.state.qs.date)}
										</div>
										<div className={"right floated font-bold font-black"}>
											{this.state.pos.name}
										</div>
									</div>
								</div>
								<div className={"daily-dividing daily-space"}/>
								{
									!this.state.is_loading
									&& this.state.histories.length > 0 ?
										this.state.histories.map((history, history_i) => {
											let change_amount = 0;
											if (history.pos_shift && history.pos_shift.change_amount) {
												change_amount = history.pos_shift.change_amount;
											}
											let discount_amount = history.discount_amount || 0;
											let total_price_withholding_tax = history.total_price_withholding_tax || 0;
											return (
												<div key={history_i}
												     className={"daily-row-space daily-pos-shift-details"}>
													{/*เปิดกะ*/}
													<div className={"row daily-space"}>
														<div
															className={"font-bold font-black"}>
													<span
														className={"time"}>{window.moment(history.pos_shift.date_created).format('hh:mm')}</span>
															<span
																style={{marginLeft: '1rem'}}>{history.pos_shift.created_user.name} </span>
															<span style={{
																marginLeft: '1rem',
																color: 'green'
															}}>เปิดกะ</span>
														</div>
													</div>
													<div className={"row daily-space"}>
														<div className={"font-bold font-black padding-tab"}>
															เงินทอน
														</div>
														<div className={"right floated font-bold font-black"}>
															{(change_amount).format(2)}
														</div>
													</div>
													{/*<div className={"row daily-space"}>*/}
													{/*	<div className={"font-bold font-black padding-tab"}>*/}
													{/*		รายการ*/}
													{/*	</div>*/}
													{/*</div>*/}
													{/*รายการสินค้า*/}
													{
														history.sell_items.length > 0 ?
															<div
																className={"items-list daily-space"}
																ref={(ref) => {
																	this['items-list-' + history.pos_shift_id] = window.$(ref)
																}}
															>
																{
																	history.sell_items.map((sell_item, sell_item_i) => {
																		return (
																			<div key={sell_item_i}
																			     className={"row daily-space"}>
																				<div
																					className={"padding-tab fixed-height"}
																					style={{
																						maxWidth: '75%',
																						fontSize: '1.6rem'
																					}}>{sell_item.product.name}</div>
																				<div
																					className={"right floated font-black"}>
																					{(sell_item.total_net_price).format(2)}
																				</div>
																			</div>
																		);
																	})
																}
															</div>
															: null
													}
													{
														history.sell_items.length > 3 ?
															<div className={"row daily-space"}>
																<div className={"padding-tab"} style={{width: '100%'}}>
																	<div
																		className={"row daily-space center-xs"}
																		style={{marginTop: '-1.5rem'}}
																	>
																		<button type="button"
																		        style={{fontSize: '1.3rem'}}
																		        className="ui button circular basic"
																		        ref={(ref) => {
																			        this['button-more-detail-' + history.pos_shift_id] = window.$(ref)
																		        }}
																		        onClick={() => {
																			        if (this['items-list-' + history.pos_shift_id].hasClass('show')) {
																				        this['items-list-' + history.pos_shift_id].removeClass("show");
																				        this['items-list-' + history.pos_shift_id].removeAttr("style");
																				        this['button-more-detail-' + history.pos_shift_id].html('อ่านเพิ่ม')
																				        return;
																			        }
																			        this['items-list-' + history.pos_shift_id].addClass("show");
																			        this['items-list-' + history.pos_shift_id].css({
																				        maxHeight: 'none',
																				        height: 'auto'
																			        });
																			        this['button-more-detail-' + history.pos_shift_id].parent().remove()
																		        }}
																		>
																			อ่านเพิ่ม
																		</button>
																	</div>
																</div>
															</div>

															: null
													}
													{/*สรุปราคา*/}
													{
														discount_amount
														&& parseFloat(discount_amount) > 0 ?
															<div className={"row daily-space"}>
																<div className={"padding-tab"}>ส่วนลดรวม</div>
																<div className={"right floated font-black"}>
																	{(discount_amount).format(2)}
																</div>
															</div>
															: null
													}
													{
														total_price_withholding_tax
														&& parseFloat(total_price_withholding_tax) > 0 ?
															<div className={"row daily-space"}>
																<div className={"padding-tab"}>หัก ณ ที่จ่าย</div>
																<div className={"right floated font-black"}>
																	{(total_price_withholding_tax).format(2)}
																</div>
															</div>
															: null
													}
													{/*ปิดกะ*/}
													<div className={"row-bg "}>
														{
															history.close_pos_shift ?
																<>
																	<div className={"row daily-space"}>
																		<div className={"font-bold font-black"}>
																	<span
																		className={"time"}>{window.moment(history.close_pos_shift.date_created).format('hh:mm')}</span>
																			<span
																				style={{marginLeft: '1rem'}}>{history.pos_shift.created_user.name}</span>
																			<span style={{
																				marginLeft: '1rem',
																				color: 'red'
																			}}>ปิดกะ</span>
																		</div>
																	</div>
																	<div className={"row daily-space"}>
																		<div
																			className={"font-bold font-black padding-tab"}>
																			เงินทอน
																		</div>
																		<div
																			className={"right floated font-bold font-black"}>
																			{(history.close_pos_shift.change_amount).format(2)}
																		</div>
																	</div>
																	{
																		history.remain_cash !== 0 ?
																			<div className={"row daily-space"}>
																				<div className={"padding-tab"}>
																					<div
																						style={{paddingLeft: '2.6rem'}}>
																						{
																							history.remain_cash > 0 ?
																								"เงินเกิน"
																								: null
																						}
																						{
																							history.remain_cash < 0 ?
																								"เงินขาด"
																								: null
																						}
																					</div>
																				</div>
																				<div
																					className={"right floated font-black"}>
																					{(history.remain_cash || 0).format(2)}
																				</div>
																			</div>
																			: null
																	}
																</>
																: null
														}
														<div className={"row daily-space"}>
															<div className={"font-bold font-black padding-tab"}>
																สรุป
															</div>
														</div>
														{
															history.payment_bys.map((payment_by, payment_by_i) => {
																if (payment_by.price === 0) return null;
																return (
																	<div key={payment_by_i}
																	     className={"row daily-space"}>
																		<div
																			className={"padding-tab"}>{payment_by.payment_by2}</div>
																		<div className={"right floated font-black"}>
																			{(payment_by.price).format(2)}
																		</div>
																	</div>
																);
															})
														}

														<div className={"row daily-space"}>
															<div className={"padding-tab"}>ยอดรวม</div>
															<div className={"right floated font-black"}>
																{(history.total_net_price).format(2)}
															</div>
														</div>
													</div>
												</div>
											)
										}) : null
								}
								{
									!this.state.is_loading
									&& this.state.histories.length === 0 ?
										<div className={"daily-row-space center-xs"} style={{paddingBottom: '1.8rem'}}>
											<div className={"daily-space font-bold font-black"}>
												ไม่มีข้อมูล
											</div>
										</div>
										: null
								}
								{
									this.state.is_loading ?
										<div className={"daily-row-space  center-xs"} style={{paddingBottom: '1.8rem'}}>
											<div className={"daily-space font-bold font-black"}>
												<div className="ui active inline small loader"
												     style={{top: -2, marginRight: '1rem'}}/>
												กำลังโหลดข้อมูล
											</div>
										</div>
										: null
								}
								{
									!this.state.is_loading
									&& this.state.summary.length > 0
									&& this.state.histories.length > 0 ?
										<div className={"daily-summary-box daily-row-space"}>
											{
												this.state.summary.map((summary, summary_i) => {
													if (parseFloat(summary.value) === 0) {
														return null;
													}
													return (
														<div className={"row daily-space"} key={summary_i}>
															<div
																className={summary.title === "ยอดขายทั้งหมด" ? "font-bold font-black" : null}>{summary.title}</div>
															<div className={"right floated font-bold font-black"}>
																{(summary.value).format(2)}
															</div>
														</div>)
												})
											}
										</div>
										: null
								}

							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}